import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgUpdate = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.03009 7.78323C2.03009 11.0304 4.38444 13.2424 7.02819 13.7002C7.33072 13.7525 7.5335 14.0402 7.48112 14.3428C7.42874 14.6453 7.14102 14.8481 6.8385 14.7957C3.73271 14.2579 0.918228 11.6402 0.918228 7.78323C0.918227 6.1441 1.66396 4.85596 2.53481 3.87603C3.15865 3.17407 3.87236 2.60412 4.44636 2.1675H2.70085C2.4063 2.1675 2.16752 1.92871 2.16752 1.63416C2.16752 1.33961 2.4063 1.10083 2.70085 1.10083H5.90085C6.1954 1.10083 6.43419 1.33961 6.43419 1.63416V4.83416C6.43419 5.12871 6.1954 5.3675 5.90085 5.3675C5.6063 5.3675 5.36752 5.12871 5.36752 4.83416V2.86556L5.36591 2.86677C4.75634 3.32652 4.01129 3.88841 3.36591 4.61462C2.60375 5.47223 2.03009 6.50832 2.03009 7.78323ZM13.8783 8.21677C13.8783 5.0039 11.5739 2.80492 8.9641 2.31498C8.66232 2.25833 8.46363 1.96778 8.52028 1.66601C8.57693 1.36425 8.86748 1.16556 9.16924 1.22221C12.2351 1.79778 14.9901 4.40113 14.9901 8.21677C14.9901 9.85588 14.2444 11.144 13.3735 12.124C12.7497 12.8259 12.0359 13.3959 11.462 13.8325H13.2076C13.5021 13.8325 13.7409 14.0713 13.7409 14.3659C13.7409 14.6604 13.5021 14.8992 13.2076 14.8992H10.0075C9.71297 14.8992 9.47419 14.6604 9.47419 14.3659V11.1659C9.47419 10.8713 9.71297 10.6325 10.0075 10.6325C10.3021 10.6325 10.5409 10.8713 10.5409 11.1659V13.1344L10.5425 13.1331C11.1521 12.6734 11.8971 12.1116 12.5424 11.3854C13.3046 10.5278 13.8783 9.49168 13.8783 8.21677Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgUpdate)
const IconSvgUpdate = createIcon(ForwardRef, 'SvgUpdate')
export default IconSvgUpdate
